import React, { FC } from 'react';
import { TProgress } from 'components/Progress/types';
import SProgress from 'components/Progress/style';

const Progress: FC<TProgress> = props => {
  return <SProgress {...props} />;
};
export default Progress;
